import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import UserProvider from './providers/userProvider';
import Home from './pages/home/home';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import './App.css';
import Article from './pages/article/article';
import Services from './pages/services/services';
import Platforms from './pages/platforms/platforms';
import Unauthorized from './pages/unauthorized/unauthorized';
import DiningRooms from './pages/diningRooms/diningRooms';
import Benefits from './pages/benefits/benefits';
import Agreements from './pages/agreements/agreements';
import ListByAgreement from './pages/listByAgreement/listByAgreement';
import Culture from './pages/culture/culture';
import Emergencies from './pages/emergencies/emergencies';
import Calendar from "./pages/calendar/calendar";
import Communications from "./pages/communications/communications";

function App() {
  return (
    <BrowserRouter>
      <UserProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/index.html" element={<Navigate to="/" />} />
          <Route path="/article" element={<Article/>} />
          <Route path="/services" element={<Services/>} />
          <Route path="/platforms" element={<Platforms/>} />
          <Route path="/dinningRooms" element={<DiningRooms/>} />
          <Route path="/benefits" element={<Benefits/>} />
          <Route path="/agreements" element={<Agreements />} />
          <Route path="/agreementList" element={<ListByAgreement />} />
          <Route path="/culture" element={<Culture />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/communications" element={<Communications />} />
          <Route path="/emergencies" element={<Emergencies />} />
          <Route path="/unauthorized" element={<Unauthorized/>} />
        </Routes>
      </UserProvider>
      </BrowserRouter>
  );
}

export default App;
